import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReminderForm from './ReminderForm.jsx'
//import _ from 'lodash'

class ReminderComponent extends Component{
  componentDidMount() {
    this.props.fetchData()
  }

  render() {
    if (this.props.reminder) {
      return <div><ReminderForm reminder={this.props.reminder}></ReminderForm></div>
    }
    return <div></div>
  }
}

ReminderComponent.propTypes = {
  fetchData: PropTypes.func.isRequired,
  reminder: PropTypes.object.isRequired,
}

export default ReminderComponent
